<template>
  <a-modal
    ref="createModal"
    title="新增分类转换关系"
    :width="1000"
    :visible="visible"
    :maskClosable="false"
    @cancel="close"
    @ok="confirm"
    :confirmLoading="confirmLoading"
  >
    <div class="table-page-operator-wrapper">
      <a-button @click="addLine()" type="primary">新增行</a-button>
    </div>
    <a-table
      ref="modalTable"
      :columns="columns"
      :data-source="typeList"
      :pagination="false"
      row-key="indexId"
    >
      <!-- 物料编码 -->
      <span slot="itemCodeTitle">
        <i class="toRequired">*</i>物料编码
      </span>
      <template slot="itemId" slot-scope="text, record">
        <global-select
          :value.sync="record.itemId"
          :dropdown-match-select-width="false"
          selectType="selectAssembleSearch"
          requestApi="/mes/mesDiscreteJobs/assemblyBox"
          :selectItem="{ value: 'selectedValue', label: 'bringOutDataOne' }"
          searchParam="itemCode" />
      </template>

      <!-- 来源单位 -->
      <span slot="unitOfMeasureTitle">
        <i class="toRequired">*</i>来源单位
      </span>
      <template slot="unitOfMeasure" slot-scope="text, record">
        <a-select show-search option-filter-prop="children" v-model="record.unitOfMeasure" @change="handleSelect(record, 'unitOfMeasure')">
          <a-select-option v-for="(item) in unitOfMeasureList" :key="item.key">{{ item.value }}</a-select-option>
        </a-select>
      </template>
      <!-- 折换 -->
      <span slot="conversionRateTitle">
        <i class="toRequired">*</i>折换
      </span>
      <template slot="conversionRate" slot-scope="text, record">
        <a-popover>
          <template slot="content">
            <p>即换算比例，1*折换*来源单位=1*目标单位</p>
          </template>
          <a-input-number v-model="record.conversionRate" :min="0" size="small" @blur="blur(record)" />
        </a-popover>
      </template>
      <!-- 倒数 -->
      <template slot="conversionRateInverse" slot-scope="text, record">
        <a-popover>
          <template slot="content">
            <p>即换算比例倒数，1*倒数*来源单位=1*目标单位</p>
          </template>
          <span>{{ record.conversionRateInverse }}</span>
        </a-popover>
      </template>
      <!-- 目标单位 -->
      <span slot="toUnitOfMeasureTitle">
        <i class="toRequired">*</i>目标单位
      </span>
      <template slot="toUnitOfMeasure" slot-scope="text, record">
        <a-select show-search option-filter-prop="children" v-model="record.toUnitOfMeasure" @change="handleSelect(record, 'toUnitOfMeasure')">
          <a-select-option v-for="(item) in unitOfMeasureList" :key="item.key">{{ item.value }}</a-select-option>
        </a-select>
      </template>
      <span slot="operation" slot-scope="text, record">
        <a @click="handleDelete(typeList, record)">删除</a>
      </span>
    </a-table>
  </a-modal>
</template>

<script>
import { apiMdmUomConversionsUnitToData, apiMdmUomClassesAdd, apiMdmUomUnitsOfMeasureUnitOfMeasureList } from '@/api/mdm/units/classification-unit'
// 表单字段
export default {
  props: {},
  data () {
    return {
      // 状态数据字典
      baseUomFlagOptions: [
        {
          dictLabel: "是",
          dictValue: "Y"
        },
        {
          dictLabel: "否",
          dictValue: "N"
        }
      ],
      // 当前控件配置:
      confirmLoading: false,
      visible: false,
      columns: [
        {
          // title: '物料编码',
          width: 150,
          dataIndex: 'itemId',
          scopedSlots: { customRender: 'itemId', title: "itemCodeTitle" }
        },
        {
          // title: '来源单位',
          width: 150,
          dataIndex: 'unitOfMeasure',
          scopedSlots: { customRender: 'unitOfMeasure', title: "unitOfMeasureTitle" }
        },
        {
          title: '来源分类',
          dataIndex: 'lookupCodeLabel'
        },
        {
          // title: '折换',
          width: 150,
          dataIndex: 'conversionRate',
          scopedSlots: { customRender: 'conversionRate', title: "conversionRateTitle" }
        },
        {
          title: '倒数',
          dataIndex: 'conversionRateInverse',
          scopedSlots: { customRender: 'conversionRateInverse' }
        },
        {
          // title: '目标单位',
          width: 150,
          dataIndex: 'toUnitOfMeasure',
          scopedSlots: { customRender: 'toUnitOfMeasure', title: "toUnitOfMeasureTitle" }
        },
        {
          title: '目标分类',
          dataIndex: 'toLookupCodeLabel'
        },
        {
          title: '操作',
          width: 100,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' }
        }
      ],
      typeList: [],
      unitOfMeasureList: [] // 目标单位
    }
  },
  created () {
    this.getUnitOfMeasureList()
  },
  methods: {
    // 目标单位-下拉框数据
    getUnitOfMeasureList () {
      apiMdmUomUnitsOfMeasureUnitOfMeasureList().then(res => {
        if (res.code === 200 && res.data && res.data.length > 0) {
          const arr = res.data;
          const list = [];
          arr.forEach(element => {
            const obj = {
              key: element.realValue,
              value: element.label
            }
            list.push(obj)
          });
          this.unitOfMeasureList = list
        }
      })
    },
    // 列表-折换字段
    blur (record) {
      if (!record.conversionRate || Number(record.conversionRate) <= 0) {
        this.$message.warning('折换不能为空且需大于0')
      } else {
        record.conversionRateInverse = this.$countBackwards(Number(record.conversionRate))
      }
    },
    // 目标单位
    handleSelect (record, val) {
      const params = {
        unitOfMeasure: val === 'unitOfMeasure' ? record.unitOfMeasure : record.toUnitOfMeasure
      }
      apiMdmUomConversionsUnitToData(params).then(res => {
        if (res.code === 200 && res.data) {
          if (val === 'unitOfMeasure') {
            record.lookupCodeLabel = res.data.comboBoxVO.realValue
            record.lookupCode = res.data.comboBoxVO.label
          }
          if (val === 'toUnitOfMeasure') {
            record.toLookupCodeLabel = res.data.comboBoxVO.realValue
            record.toLookupCode = res.data.comboBoxVO.label
          }
        }
      })
    },
    // 删除
    handleDelete (arr, record) {
      arr.forEach((item, index) => {
        if (item.indexId === record.indexId) {
          arr.splice(index, 1);
        }
      });
    },
    show () {
      this.addLine()
      this.visible = true
    },
    // 新增行
    addLine () {
      const arr = JSON.parse(JSON.stringify(this.typeList))
      const indexId = arr.length > 0 ? arr[arr.length - 1].indexId : 0
      const obj = {
        itemId: "",
        unitOfMeasure: "",
        lookupCodeLabel: "",
        lookupCode: "",
        conversionRate: "",
        conversionRateInverse: "",
        toUnitOfMeasure: "",
        toLookupCodeLabel: "",
        toLookupCode: "",
        status: "Y",
        indexId: Number(indexId) + 1
      }
      arr.push(obj)
      this.typeList = arr
    },
    // 关闭模态框
    close () {
      this.reset()
      this.visible = false
    },
    // 保存
    confirm () {
      let flag = false
      for (let i = 0; i < this.typeList.length; i++) {
        if (!this.typeList[i].itemId || !this.typeList[i].unitOfMeasure || !this.typeList[i].toUnitOfMeasure) {
          this.$message.warning('必填项不能为空！')
          flag = true
          return
        }
        if (!this.typeList[i].conversionRate || Number(this.typeList[i].conversionRate) <= 0) {
          this.$message.warning('折换不能为空且需大于0')
          flag = true
          return
        }
      }
      if (flag) {
        return false
      }
      this.confirmLoading = true
      apiMdmUomClassesAdd(this.typeList).then(response => {
        if (response.code === 200) {
          this.$message.success('新增成功')
          // 关闭本组件
          this.visible = false
          // 调用外部刷新列表方法
          this.$emit('handle-success')
          // 刷新表单
          this.reset()
          this.confirmLoading = false
        } else {
          this.$message.error(response.msg)
          this.confirmLoading = false
        }
      }).catch(e => {
        this.confirmLoading = false
      })
    },
    // 表单重置
    reset () {
      this.typeList = []
    }
  }
}
</script>

<style scoped lang="less">
/deep/.ant-select{
  width: 120px;
}
/deep/.ant-modal-body{
  height: 400px;
  overflow-y: scroll;
}
</style>
